import Vue from 'vue'; // eslint-disable-line no-unused-vars
if (process.env.NODE_ENV === 'production') {
    Vue.config.devtools = false;
    Vue.config.debug = false;
    Vue.config.silent = true;
}
